<template>
  <div class="sec-vistext-a-base">

  </div>
</template>

<script>
export default {
  name: "SecVisTextA",
  data() {
    return {
      limitLen: 3
    }
  },
  props: {
    tagId: {
      type: Number,
      default(){
        return -1
      }
    },
    itemsReceive: {
      type: Array,
      default(){
        return []
      }
    }
  },
  computed: {
    items() {
      let rtnArr = []
      if(this.itemsReceive.length > this.limitLen) {
        for( let i = 0; i < this.limitLen; i++ ) {
          rtnArr.push(this.itemsReceive[i])
        }
      }else{
        rtnArr = this.itemsReceive
      }
      return rtnArr
    }
  },
  methods: {
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.sec-vistext-a-base {
  height: 160px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecVisTextA.vue